import { Album } from "../../../../types"
import { albumRole } from '../lib/album-role'
import AlbumCard from './album-card'

export interface AlbumGridProps {
  currentAlbums: Album[]
  isDevelopment: boolean
  onDragStart: (album: Album) => void
  onDragEnd: () => void
  onDoubleClick: (albumId: string) => void
  onRename: (albumId: string, newName: string) => void
  onDelete: (albumId: string) => void
  onChangeDate: (albumId: string, newDate: string) => void
  onShare: (albumId: string) => void
  onDownload: (albumId: string) => void
  onAlbumDrop: (album: Album | null, targetAlbumId: string) => void
  onUpload: (albumId: string) => void
  draggedAlbum: Album | null
  isDragging: boolean
}

// Presentational only: the `.album-grid` and its per-album `AlbumCard`s.
// Every handler arrives as a prop; the ownership/emptiness gating that
// decides whether AlbumCard receives a callback or `undefined` lives here,
// moved verbatim from album-list.tsx (SOL-150).
export default function AlbumGrid({
  currentAlbums,
  isDevelopment,
  onDragStart,
  onDragEnd,
  onDoubleClick,
  onRename,
  onDelete,
  onChangeDate,
  onShare,
  onDownload,
  onAlbumDrop,
  onUpload,
  draggedAlbum,
  isDragging,
}: AlbumGridProps) {
  return (
    <div className="album-grid">
      {currentAlbums.map((album) => {
        const isOwner = albumRole(album) === 'owner';

        return (
          <AlbumCard
            key={album.uuid}
            album={album}
            isDevelopment={isDevelopment}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
            onDoubleClick={() => onDoubleClick(album.uuid)}
            onRename={isOwner ? (newName: string) => onRename(album.uuid, newName) : undefined}
            onDelete={isOwner ? () => onDelete(album.uuid) : undefined}
            onChangeDate={isOwner ? (newDate: string) => onChangeDate(album.uuid, newDate) : undefined}
            onShare={album.isEmpty ? undefined : onShare}
            onDownload={album.isEmpty ? undefined : onDownload}
            onAlbumDrop={onAlbumDrop}
            onUpload={() => onUpload(album.uuid)}
            draggedAlbum={draggedAlbum}
            isDragging={isDragging}
            isEmpty={album.isEmpty}
          />
        );
      })}
    </div>
  )
}
